import { render, staticRenderFns } from "./Breadcrumb.vue?vue&type=template&id=027db348&scoped=true"
var script = {}
import style0 from "./Breadcrumb.vue?vue&type=style&index=0&id=027db348&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027db348",
  null
  
)

export default component.exports